export default __webpack_public_path__ + "static/feature_02-73e850adc629af53322dafe8ac25afc3.png";